export const Measurement = {
  CAL: 'clean_air_level_min',
  Co2Ratio: 'co2_ratio_min',
  Co2: 'co2_max',
  RelativeHumidity: 'rh_avg',
  Temperature: 'temperature_avg',
  PM2: 'mass_pm_2_5_max',
  PM10: 'mass_pm_10_max',
  TVOC: 'tvoc_max',
  TVOC_MASS: 'tvoc_mass_avg',
  STATUS_ALERT: 'status_alert',
  COMFORT_LEVEL: 'comfort_level_avg',
  occupancy: 'occupancy',
  thermal_served: 'thermal_served',
  air_served: 'air_served',
  thermal_justified: 'thermal_justified',
  air_justified: 'air_justified',
  thermal_requested: 'thermal_requested',
  air_requested: 'air_requested',
  thermal_saveable: 'thermal_saveable',
  air_saveable: 'air_saveable',
  DpMean: 'dp_mean',
};

export const MeasurmentDisplayString = {
  [Measurement.CAL]: 'CAL',
  [Measurement.Co2Ratio]: 'CO2 Ratio',
  [Measurement.Co2Ratio]: 'Ventilation',
  [Measurement.Co2]: 'CO2',
  [Measurement.RelativeHumidity]: 'Relative Humidity',
  [Measurement.Temperature]: 'Temperature',
  [Measurement.PM2]: 'PM2.5 Mass',
  [Measurement.PM10]: 'PM10 Mass',
  [Measurement.TVOC]: 'Tvoc',
  [Measurement.TVOC_MASS]: 'Tvoc Mass',
  [Measurement.STATUS_ALERT]: 'Status Alert',
  [Measurement.COMFORT_LEVEL]: 'Comfort Level',
  [Measurement.occupancy]: 'Occupancy',
  [Measurement.thermal_served]: 'Comfort Served',
  [Measurement.air_served]: 'Ventilation Served',
  [Measurement.thermal_justified]: 'Comfort Justified',
  [Measurement.air_justified]: 'Ventilation Justified',
  [Measurement.thermal_requested]: 'Comfort Requested',
  [Measurement.air_requested]: 'Ventilation Requested',
  [Measurement.thermal_saveable]: 'Comfort Saveable',
  [Measurement.air_saveable]: 'Ventilation Saveable',
  [Measurement.DpMean]: 'Differential Pressure',
};
